import { useEffect, useState } from 'react';

export const LANG_CHANGE_EVENT = 'loger:langchange';

const readLang = () => {
  try {
    const saved = localStorage.getItem('selectedLang');
    return saved ? JSON.parse(saved)?.code || 'en' : 'en';
  } catch {
    return 'en';
  }
};

// Returns the language code chosen in the header flag switcher ('en', 'ar', ...)
// and re-renders when it changes.
export default function useSelectedLang() {
  const [lang, setLang] = useState(readLang);

  useEffect(() => {
    const sync = () => setLang(readLang());
    window.addEventListener(LANG_CHANGE_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(LANG_CHANGE_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return lang;
}
